import HRLayout from "../hr/HRLayout";
import useHRCopy from "../hr/i18n/useHRCopy";
import Reveal from "../hr/components/Reveal";
import PageHeader from "../hr/components/PageHeader";
import ContextRail from "../hr/components/ContextRail";
import ContactForm from "../components/ContactForm";
import { CONTACT_EMAIL } from "../hr/contact";

export default function HakkimdaPage() {
  const copy = useHRCopy();
  const t = copy.pages.hakkimda;
  const r = copy.record;

  return (
    <HRLayout>
      <PageHeader title={t.title} />

      {/* White band against the paper header and the platinum contact band, so
          the page reads as three distinct registers rather than one wash. */}
      <section className="bg-white border-y border-line">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16 lg:py-20 grid gap-10 lg:gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4 lg:order-2">
            <Reveal delay={0.09}>
              <ContextRail
                tone="onWhite"
                title={r.details}
                rows={[
                  { term: r.location, value: r.locationValue },
                  { term: r.email, value: CONTACT_EMAIL, href: `mailto:${CONTACT_EMAIL}` },
                ]}
                linksTitle={r.related}
                links={[
                  { to: "/hizmetlerim", label: copy.pages.hizmetler.title },
                  { to: "/calismailkelerim", label: copy.pages.ilkeler.title },
                  { to: "/iletisim", label: copy.nav.contact },
                ]}
              />
            </Reveal>
          </div>

          {/* The narrative is the record body. Hierarchy comes from type size
              between the two paragraphs, not from added ornament. */}
          <div className="lg:col-span-8 lg:order-1">
            <div className="border-t border-line">
              <Reveal>
                <p className="border-b border-line py-8 text-[clamp(1.25rem,2vw,1.6rem)] font-medium leading-[1.5] tracking-[-0.01em] text-ink">
                  {t.p1}
                </p>
              </Reveal>
              <Reveal delay={0.09}>
                <p className="border-b border-line py-8 text-[17px] leading-[1.8] text-steel">
                  {t.p2}
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <ContactForm />
    </HRLayout>
  );
}
